import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { LIQUID_ID_ASPECT_RATIO } from './config';
import LiquidIDCube from './LiquidIDCanvas';
import { Button } from '@/components/Sections/Profile/Buttons';

export const LiquidIDSectionWrapper = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    pointer-events: none;
    gap: 5vh;

    width: 100%;
    height: 70dvh;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: unset;
        bottom: 0;
        right: 0;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        position: relative;
        gap: 0;
    }
`;

export const LiquidIDPosition = styled(LiquidIDCube)`
    aspect-ratio: ${LIQUID_ID_ASPECT_RATIO};
    max-width: 800px;
    width: 100%;
    flex: none;
    margin: 0 auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        max-width: 40vw;
        max-height: 40vw;
    }
`;

export const EditButtonsGroup = styled(motion.div)`
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: auto;
        padding-bottom: 0;
        align-items: center;
        justify-content: center;
    }
`;

export const CreateIDButton = styled(Button)`
    &&& {
        opacity: 1;
        transition: opacity ${({ theme }) => `${theme.transitions.speeds.fast}s ${theme.transitions.easesCss.cubic}`};
        &:disabled {
            opacity: 0;
        }
    }
`;

export const CloseSelectionButton = styled(motion.button)`
    background: rgba(255, 255, 255, 0.07);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.28);
    border-radius: 30px;
    width: 45px;
    height: 45px;

    border: none;
    display: flex;
    place-items: center;
    place-content: center;
    cursor: pointer;

    svg {
        width: 12px;
        height: 12px;
    }
`;

export const LayoutSplitter = styled(motion.div)`
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    pointer-events: none;
    width: 65%;
    left: -20px;
    max-width: calc(100% - 500px);
`;

interface NavBarProps {
    $editor: boolean | undefined;
    $userLIDPreview: boolean | undefined;
}

export const NavigationBar = styled.div<NavBarProps>`
    position: absolute;
    top: 58px;
    right: 20px;
    z-index: 10;
    display: flex;
    align-content: center;
    align-items: center;
    gap: 32px;

    background-color: #090719;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        justify-content: initial;
        top: 0;
        right: 40px;
    }

    ${({ $editor }) =>
        $editor &&
        css`
            top: 22px;
            left: 23px;
            justify-content: space-between;

            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                justify-content: initial;
                top: 30px;
                right: 40px;
                left: unset;
            }
        `};
`;

export const ExpandedOwnerActionsWrapper = styled.div`
    display: flex;
    gap: 15px;
`;
